"use client";

import { useEffect, useRef } from "react";
import { ECHOPAY_SVG } from "@/assets/svgs";
import Link from "next/link";

const DATA = [
  {
    bg: "#FEFFE6",
    zIndex: 1,
    resting: "rotate(-5deg)",
    text: (
      <>
        Been using{" "}
        <Link
          href="https://x.com/resolvahq?s=21"
          target="_blank"
          className="underline"
        >
          @ResolvaHQ
        </Link>{" "}
        since January as one of the early users/testers and I've not had to use
        any other platform for Naira offramping. Try it out and share your
        experience
      </>
    ),
    name: "Ayodeji",
    role: "Founder, Web3bridge",
    avatar: "/avatar_1.svg",
  },
  {
    bg: "#E6F8FF",
    zIndex: 2,
    resting: "rotate(5deg)",
    text: (
      <>
        I used{" "}
        <Link
          href="https://x.com/resolvahq?s=21"
          target="_blank"
          className="underline"
        >
          @ResolvaHQ
        </Link>{" "}
        yesterday! Smooth experience tbh. You should try and see for yourself. I
        love it
      </>
    ),
    name: "Zara",
    role: "Community Manager",
    avatar: "/avatar_2.svg",
  },
  {
    bg: "#FFE6FD",
    zIndex: 3,
    resting: "rotate(-5deg)",
    text: (
      <>
        Off-ramping has never been this easy.
        <Link
          href="https://x.com/resolvahq?s=21"
          target="_blank"
          className="underline"
        >
          @ResolvaHQ
        </Link>{" "}
        is solving the most prevalent problem in crypto 9ja, and they are doing
        in the most seamless way possible. Fast registration and KYC, 10 sec
        withdrawal confirmation and supports multiple chains.
      </>
    ),
    name: "Uche",
    role: "Host, Starknet Espresso",
    avatar: "/avatar_3.svg",
  },
  {
    bg: "#ECFFE6",
    zIndex: 4,
    resting: "rotate(5deg)",
    text: (
      <>
        Tried{" "}
        <Link
          href="https://x.com/resolvahq?s=21"
          target="_blank"
          className="underline"
        >
          @ResolvaHQ
        </Link>{" "}
        today… blinked and the naira was already in my account. No P2P stress,
        no waiting.{" "}
        <Link
          href="https://x.com/resolvahq?s=21"
          target="_blank"
          className="underline"
        >
          @ResolvaHQ
        </Link>{" "}
        did crypto to naira in seconds!!
      </>
    ),
    name: "Marvelous",
    role: "Blockchain Developer",
    avatar: "/avatar_4.svg",
  },
  {
    bg: "#FEFFE6",
    zIndex: 5,
    resting: "rotate(-5deg)",
    text: (
      <>
        Been using{" "}
        <Link
          href="https://x.com/resolvahq?s=21"
          target="_blank"
          className="underline"
        >
          @ResolvaHQ
        </Link>{" "}
        since January as one of the early users/testers and I've not had to use
        any other platform for Naira offramping. Try it out and share your
        experience
      </>
    ),
    name: "Ayodeji",
    role: "Founder, Web3bridge",
    avatar: "/avatar_1.svg",
  },
  {
    bg: "#FFE6FD",
    zIndex: 6,
    resting: "rotate(5deg)",
    text: (
      <>
        I used{" "}
        <Link
          href="https://x.com/resolvahq?s=21"
          target="_blank"
          className="underline"
        >
          @ResolvaHQ
        </Link>{" "}
        yesterday! Smooth experience tbh. You should try and see for yourself. I
        love it
      </>
    ),
    name: "Zara",
    role: "Community Manager",
    avatar: "/avatar_2.svg",
  },
];

const CARD_W = 368;
const CARD_STEP = CARD_W; // 310px — effective horizontal step per card
const SPEED = 1;

function Card({
  item,
  style,
  refCb,
}: {
  item: (typeof DATA)[0];
  style?: React.CSSProperties;
  refCb?: (el: HTMLDivElement | null) => void;
}) {
  return (
    <div
      ref={refCb}
      className="w-[368px] min-h-[350px] rounded-[22px] border-4 border-white flex flex-col justify-between pt-6 px-[22px] pb-[22px] absolute"
      style={{
        backgroundColor: item.bg,
        zIndex: item.zIndex,
        ...style,
      }}
    >
      <div>
        {ECHOPAY_SVG().quote()}
        <p className="text-base leading-[28px] tracking-[-0.15px] text-[#010721] mt-4">
          {item.text}
        </p>
      </div>
      <div className="flex items-center gap-3 mt-6">
        <div className="w-[46px] h-[46px] rounded-full overflow-hidden shrink-0">
          <img src={item.avatar} alt="" />
        </div>
        <div>
          <p className="text-base leading-[28px] tracking-[-0.15px] font-bold text-[#010721]">
            {item.name}
          </p>
          <p className="text-sm leading-[17px] tracking-[-0.15px] text-[#79747E] mt-[2px]">
            {item.role}
          </p>
        </div>
      </div>
    </div>
  );
}

export function Testimonials() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  // One ref per card — used for both drop animation and rAF left updates
  const cardRefs = useRef<(HTMLDivElement | null)[]>([]);

  // Tracked x positions for each card (in px, relative to container)
  const positionsRef = useRef<number[]>(DATA.map((_, i) => i * CARD_STEP));

  const rafRef = useRef<number | null>(null);
  const scrollingRef = useRef(false);
  const pausedRef = useRef(false);
  const triggeredRef = useRef(false);

  // ── rAF scroll loop ──────────────────────────────────────────────────────
  const scrollStep = () => {
    if (!scrollingRef.current || pausedRef.current) return;

    // Move every card left by SPEED px
    const next = positionsRef.current.map((x) => x - SPEED);

    // Find the current rightmost x BEFORE recycling (so recycled card lands correctly)
    const maxX = Math.max(...next);

    // Recycle any card whose right edge has left the viewport left boundary
    const recycled = next.map((x) => (x + CARD_W < 0 ? maxX + CARD_STEP : x));

    positionsRef.current = recycled;

    // Apply imperatively — no React re-render needed
    cardRefs.current.forEach((card, i) => {
      if (card) card.style.left = `${recycled[i]}px`;
    });

    rafRef.current = requestAnimationFrame(scrollStep);
  };

  // ── Drop + scroll trigger ────────────────────────────────────────────────
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting || triggeredRef.current) return;
        triggeredRef.current = true;
        observer.disconnect();

        // 1. Set initial left positions on each card
        cardRefs.current.forEach((card, i) => {
          if (card) card.style.left = `${positionsRef.current[i]}px`;
        });

        // 2. Park cards above viewport (no transition so jump is instant)
        cardRefs.current.forEach((card, i) => {
          if (!card) return;
          const rotPart = DATA[i].resting.match(/rotate\([^)]+\)/)?.[0] ?? "";
          card.style.transition = "none";
          card.style.transform = `translateY(-700px) ${rotPart}`;
          card.style.opacity = "0";
          card.getBoundingClientRect(); // force reflow
          card.style.transition =
            "transform 1.5s cubic-bezier(0.34,1.24,0.64,1), opacity 0.4s ease";
        });

        // 3. Drop cards with stagger
        cardRefs.current.forEach((card, i) => {
          if (!card) return;
          setTimeout(() => {
            card.style.transform = DATA[i].resting;
            card.style.opacity = "1";
          }, i * 200);
        });

        // 4. Start rAF scroll after last card lands
        // last card: 3*200=600ms delay + ~1450ms transition ≈ 2050ms
        setTimeout(() => {
          scrollingRef.current = true;
          rafRef.current = requestAnimationFrame(scrollStep);
        }, 3 * 200 + 1450);
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // ── Hover pause / resume ─────────────────────────────────────────────────
  useEffect(() => {
    const el = wrapperRef.current;
    if (!el) return;

    const pause = () => {
      pausedRef.current = true;
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };

    const resume = () => {
      if (!scrollingRef.current) return;
      pausedRef.current = false;
      rafRef.current = requestAnimationFrame(scrollStep);
    };

    el.addEventListener("mouseenter", pause);
    el.addEventListener("mouseleave", resume);
    return () => {
      el.removeEventListener("mouseenter", pause);
      el.removeEventListener("mouseleave", resume);
    };
  }, []);

  // ── Cleanup on unmount ───────────────────────────────────────────────────
  useEffect(() => {
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return (
    <section ref={sectionRef} className="w-full pt-24 lg:pt-36 px-4 font-inter">
      <div className="flex flex-col gap-2 md:gap-4 items-center text-center mb-4">
        <h2 className="font-semibold font-onest text-3xl md:text-4xl lg:text-5xl leading-[32px] md:leading-[40px] lg:leading-[48px] tracking-[0.35px] text-[#010721] max-w-[50rem]">
          Don’t just take our word for it. See what everyone’s chatting about!
        </h2>
        <p className="font-normal text-sm md:text-base lg:text-lg tracking-[-0.44px] text-[#010721] w-full md:max-w-[29rem]">
          The fastest, simplest way to bridge crypto and traditional banking,
          built for speed and clarity.
        </p>
      </div>

      {/*
        overflow-x:clip  → hides cards scrolling off left/right edges
        overflow-y:visible → lets cards fall in from above during drop
        h-[440px]        → fixed height required since cards are absolute
      */}
      <div
        ref={wrapperRef}
        className="w-full h-[400px] max-w-[90rem] mx-auto relative"
        style={{ overflowX: "clip", overflowY: "visible" }}
      >
        {DATA.map((item, i) => (
          <Card
            key={i}
            item={item}
            refCb={(el) => {
              cardRefs.current[i] = el;
            }}
            style={{
              opacity: 0,
              transform: item.resting,
              left: positionsRef.current[i],
              top: 40, // vertical breathing room inside the container
            }}
          />
        ))}
      </div>
    </section>
  );
}
